// @flow

import React from 'react'
import { renderToString } from 'react-dom/server';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bindAll from 'lodash/bindAll'
import { List, Map, fromJS } from 'immutable'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import moment from 'moment'
import PaginationSupport from '../partials/PaginationSupport'
import $ from 'jquery'
import io from "socket.io-client";

import {
	assessmentVersionFetchData,
	assessmentsAddFilterPageNumber,
	assessmentsAddFilterSearch,
	companiesAddFilterSort,
	companiesAddFilterName,
	assessmentsAddFilterColPerPage,
	companiesAddFilterStatus,
	assessmentsVersionClearFilterData,
	companiesAddFilterChannel,
  assessmentsVersionAddFilterAssessmentName,
	assessmentVersionRollback,
	assessmentVersionUpdate,
	assessmentVersionCheckQueue,
	assessmentStatusQueueSet,
} from '../../actions/assessment'

import{
  globalAddSweetAlertData,
	globalHideSweetAlert,
} from '../../actions/global'

import {
	getSocketAddress,
	defineLiveOrBeta,
} from '../../helpers/global'

import ModalDownloadAllAccounts from '../partials/ModalDownloadAllAccounts'
import ModalConnectPopskul from '../partials/ModalConnectPopskul'

import TableLoader from '../partials/TableLoader'

require('es6-promise').polyfill()

type Props = {
	assessmentVersionFetchData: Function,
	assessmentVersionFetchDataAsync: Function,
	assessmentsPagination: Map<string, any>,
	companies: List<Map<string, any>>,
	companiesFilterData: Map<string, any>,
	assessmentsAddFilterPageNumber: Function,
	globalIndicatorData: Map<string, any>,
	assessmentsAddFilterSearch: Function,
	companiesAddFilterSort: Function,
	companiesAddFilterName: Function,
	assessmentsAddFilterColPerPage: Function,
	companiesAddFilterStatus: Function,
	companiesAddFilterChannel: Function,
};

type State = {
	isShown: boolean
};

class AssessmentVersionList extends React.Component<Props, State> {
	state: State;

	constructor(props) {
		super(props)

		this.state = {
			isShown: false,
			selectedCompany:{}
		}
		this.socket = io(getSocketAddress());
		bindAll(this, [
			'handleSortChange',
			'handleSearchByName',
			'handleChangePageSize',
			'handleFilterByStatus',
			'handleModalDownload',
			'creditFormatter',
			'titleFormatter',
			'handleSelectRow',
			'dateFormatter',
			'popskulActionFormater',
			'handleConnectDisconnectPopskul',
			'onCloseModal',
      'statusFormatter',
      'handleUpdateNorm',
			'handleClickDetail',
			'connectSocket',
			'handleSocket',
			'fetchDataVersion',

		])
	}


		componentWillUnmount() {
			this.socket.disconnect();
		}

	 connectSocket(assessment_name) {

   
      this.socket.on(
        `channel:check-assessment-version-${assessment_name}-${defineLiveOrBeta()}`,
        message => {
          this.handleSocket(message);
        }
      );
    
  }

	fetchDataVersion(){
		const {
			assessmentVersionFetchData,
			assessmentsVersionClearFilterData,
			assessmentsVersionFilterData,
      assessment_name,
      assessmentsVersionAddFilterAssessmentName,
			assessmentVersionCheckQueue,

		} = this.props
			assessmentsVersionClearFilterData()
			.then(()=>{
					assessmentsVersionAddFilterAssessmentName(assessment_name)
					.then(()=>{
						assessmentVersionFetchData(this.props.assessmentsVersionFilterData)
					
					})
					
			})
	}

	handleSocket(event){
  const{status,type_update}=event
	const{assessmentStatusQueueSet} = this.props
		assessmentStatusQueueSet(status,type_update)
		.then(()=>{
			this.fetchDataVersion()
		})
	}

  handleUpdateNorm(isUpdate){
    const{
      globalAddSweetAlertData,
      globalHideSweetAlert,
			assessmentVersionUpdate,
			assessmentVersionRollback,
			assessment_name,
    }=this.props;
    if (isUpdate) {
        globalAddSweetAlertData({
          show: true,
          showCancelButton: true,
          customClass: 'swal-support',
          confirmButtonColor: '#564FDB',
          confirmButtonText: 'Update',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          title: `Update Norm Score?`,
          text: "Are you sure to update the norm score? This process runs in the background, so feel free to navigate away and work on other tasks. We'll notify you once it's complete.",
          onConfirm: () => {

						assessmentVersionUpdate(assessment_name)
            globalHideSweetAlert()
          },
          onCancel: () => {
						
            globalHideSweetAlert()
          }
        })
    }else{
       globalAddSweetAlertData({
          show: true,
          showCancelButton: true,
          customClass: 'swal-support',
          confirmButtonColor: '#EA4D4D',
          confirmButtonText: 'Rollback',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          title: `Rollback Normed Score?`,
          text: "Are you sure you want to roll back the normed score? If you proceed, the system will revert to the previous version of the norm score, which may affect your current evaluations.",
          onConfirm: () => {
						assessmentVersionRollback(assessment_name)
            globalHideSweetAlert()
          },
          onCancel: () => {
            globalHideSweetAlert()
          }
        })
    }
  }

	handleClickDetail(id){
		const{assessment_name}=this.props
		this.props.history.push({ 
				pathname: `/support/assessment-dashboard/${assessment_name}/${id}`,
				state: {prevPage: `assessment-dashboard/${assessment_name}`}
			})
	}
  
	statusFormatter(cell: Object, row: Object): Object {
		let colorText='text-detail'
		let status = 'Active'
		
		return <span onClick={(e)=>{this.handleClickDetail(row.id)}} className={colorText}>{'Lihat Detail'}</span>
	}

	componentDidMount() {
		const {
			assessmentVersionFetchData,
			assessmentsVersionClearFilterData,
			assessmentsVersionFilterData,
      assessment_name,
      assessmentsVersionAddFilterAssessmentName,
			assessmentVersionCheckQueue,
			connectSocket,
		} = this.props
    console.log(assessment_name,'assessment_name')
		this.connectSocket(assessment_name)
		let prevState = this.props.location.state
		
		assessmentsVersionClearFilterData()
		.then(()=>{
        assessmentsVersionAddFilterAssessmentName(assessment_name)
        .then(()=>{
          assessmentVersionFetchData(this.props.assessmentsVersionFilterData)
					assessmentVersionCheckQueue(assessment_name)
        })
				
		})
		
	}

	handleModalDownload(e: Object){
		e.preventDefault()

		$('#modalDownloadAllAccounts').modal('show')
	}

	handleChangePageSize(e): void{
		const{
			assessmentsAddFilterPageNumber,
			assessmentVersionFetchData,
			assessmentsAddFilterColPerPage,
		}=this.props

		const countFilter = e.target.value
		assessmentsAddFilterPageNumber(1)
		.then(()=>{
			assessmentsAddFilterColPerPage(countFilter)
			.then(()=>{
				assessmentVersionFetchData(this.props.assessmentsVersionFilterData)
			})
		})

	}

	handleSortChange(name, order){
		const {
			assessmentVersionFetchData,
			companiesAddFilterSort
		} = this.props

		let sort={
			name: name,
			value: order
		}

		companiesAddFilterSort(sort).then(()=>assessmentVersionFetchData(this.props.assessmentsVersionFilterData))

	}

	handleSearchByName(event){
		const{
			assessmentsAddFilterPageNumber,
			assessmentVersionFetchData,
			assessmentsAddFilterSearch
		}=this.props

		let keywords=event.target.value
		if (event.charCode === 13) {
			assessmentsAddFilterPageNumber(1).then(()=>{
				assessmentsAddFilterSearch(keywords).then(()=>{
					assessmentVersionFetchData(this.props.assessmentsVersionFilterData)
				})
			})
    	}
	}

	handleFilterByStatus(event){
		const{
			assessmentsAddFilterPageNumber,
			assessmentVersionFetchData,
			companiesAddFilterStatus
		}=this.props

		let status=event.target.value
		assessmentsAddFilterPageNumber(1).then(()=>{
			companiesAddFilterStatus(status).then(()=>{
				assessmentVersionFetchData(this.props.companiesFilterData)
			})
		})
	}

	creditFormatter(cell: Object, row: Object): Object {
		let colorText='text-red'
		let credit = parseInt(row.candidate_credit);
		let creditUsed = parseInt(row.credit_used);
		let creditText = `${credit-creditUsed}/${creditUsed}`
		if(row.status==='Active'){
			colorText='text-green'
			creditText = row.credit_left;
		}
		return <span className={colorText}>{creditText}</span>
	}

	dateFormatter(cell: Object, row: Object): Object {
		let date = (row.created_at ? moment(row.created_at).format('MMM DD, YYYY hh:mm A') +' (UTC)' : '')
		return <span>{date}</span>
	}
	
	handleSelectRow(row, index){
		if(index <=7 ){
			this.props.history.push({ 
				pathname: `/support/university/${row.id}`,
				state: {prevPage: 'company-index'}
			})
		}
	}

	titleFormatter(cell: Object, row: Object): Object {
    const currentVersion = <span className={'text-green'}>(Current Version)</span>
		return <div>
		  <span>v{row.version} </span>
      {row.currently_used?currentVersion:''}
	  </div>						
	}

	purifyData(data){
		const sanitize_data = data.map((value,index)=>{
			 value.title = renderToString(value.title)
			 value.administrator = renderToString(value.administrator)
			 value.email = renderToString(value.email)
			 return value
		})

		return sanitize_data;
	}

	popskulActionFormater(cell, row){
		const {
			userPrivilege, 
			userAuth
		} = this.props

		// let itSelf=userAuth.get('id')==row.id ? true : false
		// let myPrivilege=['UPDATE_USER','ACTIVATE_USER','RESET_USERS_PASSWORD','VISIT_USERS_DASHBOARD','SEND_EMAIL_TO_USERS','DELETE_USERS']
		// let res = userPrivilege.filter(item => myPrivilege.includes(item));
		
		// if(itSelf || res.length<1){
		// 	return null
		// }
		let buttonLabel = 'Connect'
		let buttonClass = 'button__primary'
		console.log('b', row);
		if(row.popskul_connection==1){
			buttonLabel = 'Disconnect'
			buttonClass = 'button__secondary'
		}
		return <button onClick={(e)=>this.handleConnectDisconnectPopskul(e, row)} className={`button ${buttonClass}`}>{buttonLabel}</button>
	}

	handleConnectDisconnectPopskul(e, company){
		e.preventDefault()
		this.setState({selectedCompany:company})
		$('#modalConnectPopskul').modal('show')
	}

	onCloseModal(){
		this.setState({selectedCompany:{}})
		this.props.assessmentVersionFetchData(this.props.companiesFilterData)
	}

  	render() {
		const {
			companies,
			assessmentsPagination,
			assessmentsAddFilterPageNumber,
			assessmentsVersionFilterData,
			assessmentVersionFetchData,
			globalIndicatorData,
			assessmentsVersion,
			assessmentStatusQueue,
		} = this.props
		
		let reportPagination: ?Object
		let is_onqueue = assessmentStatusQueue.get('status')
		let type_update = assessmentStatusQueue.get('type_update')
		console.log(type_update)
		console.log(getSocketAddress())
		if (!assessmentsVersion.isEmpty()) {
			reportPagination =
				<PaginationSupport
					pagination={assessmentsPagination}
					fetchData={assessmentVersionFetchData}
					filterData={assessmentsVersionFilterData}
					addPageNumber={assessmentsAddFilterPageNumber} />
		}

		const isIndicatorClass = globalIndicatorData.get('isShow')? 'p-t-56' : ''
		const options = {
			onSortChange: this.handleSortChange,
			// onRowClick: (row, columnIndex)=>this.handleSelectRow(row, columnIndex),
			noDataText: <TableLoader isFetched={this.props.isFetched}/>
		};

    let backPath = '/support/assessment-dashboard'
    	let prevState = this.props.location.state
      const assessment_title = assessmentsVersion.getIn(['0','name'])
    	return (

			<div className={isIndicatorClass}>
	      		<div className="div-support-container table">
	        		<section className="wrapper">
	          			<div className="main-content">
	            			<div className="container-fluid">
	              				<div className="big-panel">
                  <div className="flex-container">
											<Link to={{pathname : backPath, state:{prevPage:prevState}}} className="btn-support"><i className="fa fa-angle-left" style={{fontSize: '18px'}}></i> Back to Assessment Dashboard</Link>
									</div>
									<div className="flex-container">
										<h5 className="title-heading">{assessment_title}</h5>
									</div>

									<div className="flex-container flex-between">
										<div className="flex-container vertical-item--center">
											Show
											<select
												className="select-status-user"
												name="status"
												id="status"
												value={assessmentsVersionFilterData.get('per_page')}
												onChange={(e)=>this.handleChangePageSize(e)}>
												<option value="10" >10</option>
												<option value="20" >20</option>
												<option value="30" >30</option>
										  	</select>
										 	 Entries
										 
										 
										</div>
                    <div className='horizontal-item--between'>
                       <li><a href='#' onClick={(e)=>{
												if (is_onqueue) {
													return;
												}
												this.handleUpdateNorm()}} className={`btn-support-reverse ${is_onqueue?'disabled':''}`}>
												{type_update == 'delete_norm' ? <i className='fa fa-spinner fa-spin m-r-5'></i> : ''}
												Rollback Normed Score</a></li>
                      <li><a href='#' onClick={(e)=>{
												
												if (is_onqueue) {
													return;
												}
												this.handleUpdateNorm(true)
												}}  className={`btn-support m-l-12 ${is_onqueue?'disabled':''}`}>
												{type_update == 'update_norm' ? <i className='fa fa-spinner fa-spin m-r-5'></i>: ''}
												Update Normed Score</a></li>
                    </div>
                     
										
									</div>

	                				<div className="report-list-container assessment-container form-custom support-company-list">
										<BootstrapTable
											data={this.purifyData(this.props.assessmentsVersion.toJS())}
											striped={true}
											options={options}
											hover
										>
											<TableHeaderColumn width="200"  dataFormat={this.titleFormatter} dataField="version" isKey={true} dataSort={true}>Version</TableHeaderColumn>
											<TableHeaderColumn width="600" dataFormat={this.dateFormatter} dataField="created_at" dataSort={true}>Updated At</TableHeaderColumn>
											<TableHeaderColumn width="200"  dataFormat={this.statusFormatter} dataAlign='center' columnClassName="dropdown-user-support">Action</TableHeaderColumn>
											
										</BootstrapTable>
										{reportPagination}
	                				</div>
	              				</div>
	            			</div>
	          			</div>
	        		</section>
	      		</div>
	      		<ModalDownloadAllAccounts />
				<ModalConnectPopskul company={this.state.selectedCompany} onCloseModal={this.onCloseModal}/>
			</div>
    	)
  	}
}

const mapStateToProps = (state, ownProps) => {
  const assessmentData =fromJS([
    {
      'title':'Value Reflect Assessment(VRA)',
      'updated_at':'2025-04-16 03:38:28',
    },
    {
      'title':'Creative Thinking Assessment(CTA)',
      'updated_at':'2025-03-15 03:38:28'
    }
  ]) 

	return {
		// example
    assessmentData:assessmentData,
		// end of example data
		companies: state.companies,
		companiesFilterData: state.companiesFilterData,
		companiesIsLoading: state.companiesIsLoading,
		globalIndicatorData: state.globalIndicatorData,
		isFetched: state.isFetched,
		assessmentsVersionFilterData:state.assessmentsVersionFilterData,
		assessmentsVersion: state.assessmentsVersion,
		assessmentsPagination:state.assessmentsPagination,
    assessment_name: ownProps.match.params.assessment_name,
		assessmentStatusQueue: state.assessmentStatusQueue
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		assessmentVersionFetchData: (filter_data) => dispatch(assessmentVersionFetchData(filter_data)),
		assessmentsAddFilterPageNumber: (page) => dispatch(assessmentsAddFilterPageNumber(page)),
		assessmentsAddFilterSearch: (search) => dispatch(assessmentsAddFilterSearch(search)),
		companiesAddFilterSort: (sort) => dispatch(companiesAddFilterSort(sort)),
		companiesAddFilterName: (name) => dispatch(companiesAddFilterName(name)),
		assessmentsAddFilterColPerPage: (col) => dispatch(assessmentsAddFilterColPerPage(col)),
		companiesAddFilterStatus: (status) => dispatch(companiesAddFilterStatus(status)),
		assessmentsVersionClearFilterData: () => dispatch(assessmentsVersionClearFilterData()),
		companiesAddFilterChannel: (channel) => dispatch(companiesAddFilterChannel(channel)),
    assessmentsVersionAddFilterAssessmentName: (assessment_name)=> dispatch(assessmentsVersionAddFilterAssessmentName(assessment_name)),
    globalAddSweetAlertData: (options) => dispatch(globalAddSweetAlertData(options)),
		globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
		assessmentVersionUpdate:(assessment_name)=>dispatch(assessmentVersionUpdate(assessment_name)),
		assessmentVersionRollback:(assessment_name)=>dispatch(assessmentVersionRollback(assessment_name)),
		assessmentVersionCheckQueue: (assessment_name) => dispatch(assessmentVersionCheckQueue(assessment_name)),
		assessmentStatusQueueSet:(status,type_update)=>dispatch(assessmentStatusQueueSet(status,type_update)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentVersionList)
